import React, { useEffect, useState } from 'react';
import { ShieldAlert } from 'lucide-react';
import api from '@/utils/api';
import { Button } from '@/components/ui/button';

// Aviso à empresa quando o NIF está em falta ou inválido (as vagas ficam pausadas até ser corrigido).
export const NifNoticeBanner = ({ user }) => {
  const [st, setSt] = useState(null);
  useEffect(() => { api.get('/employer/nif-status').then((r) => setSt(r.data)).catch(() => setSt(null)); }, [user?.fiscal_nif, user?.company_country]);
  if (!st || st.valid) return null;
  const goFix = () => document.querySelector('[data-testid="fiscal-data-card"]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  return (
    <div className="mb-6 flex flex-wrap items-start gap-3 rounded-xl border border-red-300 bg-red-50 px-5 py-4 text-red-900" data-testid="nif-notice-banner">
      <ShieldAlert className="h-5 w-5 flex-shrink-0 text-red-700 mt-0.5" />
      <div className="flex-1 min-w-[220px] text-sm sm:text-base">
        <p className="font-semibold">
          {st.nif ? `O NIF «${st.nif}» não é válido para o país da empresa.` : 'A sua empresa ainda não tem NIF registado.'}
          {st.paused_jobs > 0 && <> {st.paused_jobs === 1 ? 'Uma vaga está' : `${st.paused_jobs} vagas estão`} em pausa por este motivo.</>}
        </p>
        <p className="mt-1 text-sm">{st.hint} Depois de corrigir, a equipa Trabadju revê e reactiva as vagas.</p>
      </div>
      <Button size="sm" onClick={goFix} className="bg-red-600 hover:bg-red-700" data-testid="nif-notice-fix-btn">Corrigir NIF</Button>
    </div>
  );
};
